import { atom } from 'jotai';

export const darkModeAtom = atom<boolean>(false);

export const COLORS = {
  primary: '#60a3bc',
  secondary: '#fad390',
} as const;